export const classNames = (classes) => classes.map((cl) => `${cl}`).join(' ')